import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
];

//FOR 880 MODULE ONLY
export default class Product_Buyer extends Framework.Components.View {
	constructor(props) {
		super(props, '');
	}
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>
				<div>
					<Objects.Custom880Buyer
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
						baseUrl={"/products/product_buyers"}
					/>
				</div>
			</div>
		);
	}
}

